export const SET_HRMS6KE_INDEX_DISP = 'SET_HRMS6KE_INDEX_DISP'
export const GET_HRMS6KE_INDEX_DISP = 'GET_HRMS6KE_INDEX_DISP'
export const SET_HRMS6KE_DETAIL_DISP = 'SET_HRMS6KE_DETAIL_DISP'
export const GET_HRMS6KE_DETAIL_DISP = 'GET_HRMS6KE_DETAIL_DISP'
export const SET_HRMS6KE_COLUMNS = 'SET_HRMS6KE_COLUMNS'
export const GET_HRMS6KE_COLUMNS = 'GET_HRMS6KE_COLUMNS'
export const SET_HRMS6KE_LABELS = 'SET_HRMS6KE_LABELS'
export const GET_HRMS6KE_LABELS = 'GET_HRMS6KE_LABELS'
export const RECEIVED_HRMS6KE_COLUMNS_LABELS = 'RECEIVED_HRMS6KE_COLUMNS_LABELS'
export const SET_HRMS6KE_INDEX = 'SET_HRMS6KE_INDEX'
export const GET_HRMS6KE_INDEX = 'GET_HRMS6KE_INDEX'
export const SET_HRMS6KE_INDEX_SELECTED = 'SET_HRMS6KE_INDEX_SELECTED'
export const GET_HRMS6KE_INDEX_SELECTED = 'GET_HRMS6KE_INDEX_SELECTED'
export const RECEIVED_HRMS6KE_INDEX = 'RECEIVED_HRMS6KE_INDEX'
export const RECEIVED_HRMS6KE_CREATE = 'RECEIVED_HRMS6KE_CREATE'
export const SET_HRMS6KE_CURRENT_NUMSEQ = 'SET_HRMS6KE_CURRENT_NUMSEQ'
export const GET_HRMS6KE_CURRENT_NUMSEQ = 'GET_HRMS6KE_CURRENT_NUMSEQ'
export const RECEIVED_HRMS6KE_CURRENT_NUMSEQ = 'RECEIVED_HRMS6KE_CURRENT_NUMSEQ'
export const SET_HRMS6KE_DETAIL = 'SET_HRMS6KE_DETAIL'
export const GET_HRMS6KE_DETAIL = 'GET_HRMS6KE_DETAIL'
export const RECEIVED_HRMS6KE_DETAIL = 'RECEIVED_HRMS6KE_DETAIL'
export const SET_HRMS6KE_DROPDOWNS = 'SET_HRMS6KE_DROPDOWNS'
export const GET_HRMS6KE_DROPDOWNS = 'GET_HRMS6KE_DROPDOWNS'
export const RECEIVED_HRMS6KE_DROPDOWNS = 'RECEIVED_HRMS6KE_DROPDOWNS'
export const TOGGLE_HRMS6KE_PAGE = 'TOGGLE_HRMS6KE_PAGE'
export const POST_HRMS6KE_SAVE = 'POST_HRMS6KE_SAVE'
export const POST_HRMS6KE_DELETE = 'POST_HRMS6KE_DELETE'

export const GET_HRMS6KE_DETAIL_INLINE_DATA = 'GET_HRMS6KE_DETAIL_INLINE_DATA'
export const SET_HRMS6KE_DETAIL_INLINE_DATA = 'SET_HRMS6KE_DETAIL_INLINE_DATA'
export const SET_HRMS6KE_DETAIL_ADD_INLINE = 'SET_HRMS6KE_DETAIL_ADD_INLINE'
export const RECEIVED_HRMS6KE_DETAIL_ADD_INLINE = 'RECEIVED_HRMS6KE_DETAIL_ADD_INLINE'

export const GET_HRMS6KE_DETAIL_TAB2_PROCESS = 'GET_HRMS6KE_DETAIL_TAB2_PROCESS'
export const SET_HRMS6KE_DETAIL_TAB2_PROCESS = 'SET_HRMS6KE_DETAIL_TAB2_PROCESS'
export const RECEIVED_HRMS6KE_DETAIL_TAB2_PROCESS = 'RECEIVED_HRMS6KE_DETAIL_TAB2_PROCESS'

export const SET_HRMS6KE_DETAIL_TAB2_PROCESS_CODEMPID = 'SET_HRMS6KE_DETAIL_TAB2_PROCESS_CODEMPID'
export const RECEIVED_HRMS6KE_DETAIL_TAB2_PROCESS_CODEMPID = 'RECEIVED_HRMS6KE_DETAIL_TAB2_PROCESS_CODEMPID'



// WEBPACK FOOTER //
// ./src/store/modules/hrms6ke/mutation-types.js